import { API, constructApiUrl } from '../apis.config'
import { restApiClient, restApiClientBlob } from '../rest-api-client'

export const payInstallment = async (id: number) => {
  return restApiClient.url(constructApiUrl(API.enrollments.payInstallment.url, { id })).post()
}

export const payInstantInstallment = async (input: { id: number; paymentRecordId: number }) => {
  const { id, paymentRecordId } = input

  const response = await restApiClientBlob
    .url(constructApiUrl(API.enrollments.payInstantInstallment.url, { id, paymentRecordId }))
    .post({
      returnUrl: `${import.meta.env.VITE_FRONTEND_URL}/client-personal-space/${id}/reservation/payment`
    })

  const url = URL.createObjectURL(response)
  window.location.href = url // Redirect the user to the generated HTML page
  return response
}
